import { Checkbox as FuseCheckbox } from '@tvg/fuse-design/checkbox';
import { getEncodeId } from 'client/utils/utils';
import React, { FormEventHandler, useMemo } from 'react';
import { styled } from 'styled-components';

const CheckboxStyled = styled(FuseCheckbox)`
  && {
    & .fuse-checkbox__tappable-area {
      justify-content: flex-start;
      span:last-child {
        margin-left: auto;
      }
    }
    &.fuse-checkbox {
      margin-bottom: var(--spacing-space24);
    }
  }
`;

function Checkbox({
  checked,
  name,
  onChange,
  ...props
}: React.PropsWithChildren<
  {
    error: boolean;
    name: string;
    value: string;
    checked: boolean;
    fullWidth?: boolean;
    componentId?: string;
    dataTestId?: string;
    onChange: FormEventHandler<HTMLElement>;
  } & React.HTMLAttributes<HTMLInputElement>
>) {
  const encodedName = useMemo(() => getEncodeId(name), [name]);
  return <CheckboxStyled name={encodedName} isChecked={checked} onChange={onChange} {...props} />;
}

export default React.memo(Checkbox);
